import React, { useState, useEffect } from 'react';
import { useDialogsContext } from '../contexts/Dialog';
import { useCompanyContext } from '../contexts/Company';
import { useSnackbarContext } from '../contexts/Snackbar';
import { getApplications } from '../components/API';
import LoadingBackdrop from '../components/LoadingBackdrop';
import Layout from '../components/Plans/Layout';
import DeletePlan from '../components/Plans/Delete';

export default function Plans() {
  const snackbar = useSnackbarContext();
  const dialog: any = useDialogsContext();
  const { business, getUserCompany } = useCompanyContext();
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);

  async function getPlansWrapper() {
    try {
      let plans = await getApplications();
      plans = plans.map((application) => {
        application['expanded'] = false;
        return application;
      });
      setPlans(plans);
    } catch (error) {
      setPlans([]);
      snackbar.show(
        'We encountered an issue while attempting to retrieve your applications. Please try again.',
        'error',
      );
    }
  }

  async function getData() {
    setLoading(true);
    const infoNeededFromServer = [getPlansWrapper];
    if (!business) infoNeededFromServer.push(getUserCompany);
    await Promise.all(infoNeededFromServer.map((get) => get()));
    setLoading(false);
  }

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function openDeletePlanConfirmation(plan: any) {
    setSelectedPlan(plan);
    dialog.open('deletePlan');
  }

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {plans && business && (
        <Layout
          plans={plans}
          setPlans={setPlans}
          deletePlan={openDeletePlanConfirmation}
          setLoading={setLoading}
        />
      )}
      {selectedPlan && (
        <>
          <DeletePlan
            id={selectedPlan?.id}
            name={selectedPlan?.name}
            plans={plans}
            setPlans={setPlans}
          />
        </>
      )}
    </React.Fragment>
  );
}
